var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerOffIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14.497,
    viewBox: "0 0 14 14.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "power-off-solid",
    d: "M23.933.935a.933.933,0,1,0-1.867,0V7.482a.933.933,0,1,0,1.867,0Zm-4.215,2.59a.935.935,0,0,0-1.2-1.438,7,7,0,1,0,8.951,0,.935.935,0,0,0-1.2,1.438,5.133,5.133,0,1,1-6.562,0Z",
    transform: "translate(-16)",
    fill: "#00639f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerOffIcon);
export default __webpack_public_path__ + "static/media/power-off-icon.549e51c2b701685da92f358c35be8630.svg";
export { ForwardRef as ReactComponent };